import { DesignConfigCategories } from '../designConfig';
import { Shapes, Styles, TextureTypes, Types } from '../menu';

interface MenuItemType {
  category: string;
  colorGroup?: string;
  hasThumbnail?: boolean;
  isPopular?: boolean;
  name?: string;
  shape?: string;
  size?: string;
  style?: string;
  textureId: number;
  textureType?: string;
  thumbnail?: string | undefined;
  type: Types;
}

enum ColorGroup {
  BEIGE = 'Beiges',
  BLUE = 'Blues',
  BROWN = 'Browns',
  GRAY = 'Grays',
  GREEN = 'Greens',
  RED = 'Reds',
  DARK = 'Darks',
  MIXED = 'Mixed',
}

const TextureColorGroupLabelColors: { [key in ColorGroup]: string } = {
  [ColorGroup.BEIGE]: '#b8a48',
  [ColorGroup.BLUE]: '#1472A5',
  [ColorGroup.BROWN]: '#996633',
  [ColorGroup.GRAY]: '#808183',
  [ColorGroup.GREEN]: '#00A850',
  [ColorGroup.RED]: '#E44B3A',
  [ColorGroup.DARK]: '#1a1a19',
  [ColorGroup.MIXED]: '#77787a',
};

const MenuItems = [
  // Shingled Siding
  {
    category: DesignConfigCategories.WALL,
    type: Types.SHINGLED_SIDING,
    textureId: 23,
    shape: Shapes.STRAIGHT_SHAKE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.SHINGLED_SIDING,
    textureId: 24,
    shape: Shapes.STAGGERED_SHAKE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.SHINGLED_SIDING,
    textureId: 814,
    shape: Shapes.SCALLOPED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.SHINGLED_SIDING,
    textureId: 1839,
    shape: Shapes.HAND_SPLIT,
  },
  // Concrete
  {
    category: DesignConfigCategories.WALL,
    type: Types.CONCRETE,
    style: Styles.POURED,
    textureId: 446,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.CONCRETE,
    style: Styles.CINDERBLOCK,
    textureId: 29,
    hasThumbnail: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.CONCRETE,
    style: Styles.CINDERBLOCK,
    textureId: 140,
    hasThumbnail: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.CONCRETE,
    style: Styles.CINDERBLOCK,
    textureId: 447,
    hasThumbnail: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.CONCRETE,
    style: Styles.CINDERBLOCK,
    textureId: 141,
    hasThumbnail: true,
  },

  // Brick
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 47,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 194,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 433,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 143,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 449,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 163,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 448,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 307,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 190,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 131,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 207,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 793,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 792,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 135,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 162,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 87,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 321,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 320,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 239,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 368,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 110,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 246,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 136,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 331,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 510,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 398,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 336,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 36,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },

  // Stucco
  {
    category: DesignConfigCategories.WALL,
    type: Types.STUCCO,
    textureId: 88,
  },
  // Horizontal Siding

  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `3"`,
    textureId: 624,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `4"`,
    textureId: 2270,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `5"`,
    textureId: 623,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `6"`,
    textureId: 625,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `7"`,
    textureId: 626,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `8"`,
    textureId: 1299,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `10"`,
    textureId: 172,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `12"`,
    textureId: 373,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.DUTCH_LAP,
    size: `4"`,
    textureId: 1343,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.DUTCH_LAP,
    size: `4.5"`,
    textureId: 1906,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.DUTCH_LAP,
    size: `5"`,
    textureId: 1446,
  },
  // Vertical Siding
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `5"`,
    textureId: 1819,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `7"`,
    textureId: 1987,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `8"`,
    textureId: 1267,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `10"`,
    textureId: 1641,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `12"`,
    textureId: 1268,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.PANEL,
    size: `5"`,
    textureId: 1280,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.PANEL,
    size: `8"`,
    textureId: 739,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.PANEL,
    size: `10"`,
    textureId: 1479,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.TUDOR,
    textureId: 406,
  },

  // Stone
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 184,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 185,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 181,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 90,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 188,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 195,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 756,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 726,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 727,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 91,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 749,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 177,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 316,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 180,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 754,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 753,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 747,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 198,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 724,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 179,
    hasThumbnail: true,
    colorGroup: ColorGroup.MIXED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 752,
    hasThumbnail: true,
    colorGroup: ColorGroup.MIXED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 757,
    hasThumbnail: true,
    colorGroup: ColorGroup.MIXED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 755,
    hasThumbnail: true,
    colorGroup: ColorGroup.MIXED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 253,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 751,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 280,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 390,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 183,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 196,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 748,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },

  // roof
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 563,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 557,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1558,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 554,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 560,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 568,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 565,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 851,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 859,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 2207,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 556,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 858,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1547,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 2213,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 564,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 555,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1545,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 562,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 2210,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 569,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 160,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 524,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 617,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 619,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 651,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 527,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 101,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 951,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 971,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 734,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 541,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 653,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 542,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 533,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 515,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 531,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 950,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 548,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 98,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 965,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 523,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 534,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 532,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 543,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 553,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 158,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 537,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 99,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 530,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 161,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 539,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 614,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 733,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 552,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 540,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 97,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 550,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 96,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1310,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 656,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 963,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 528,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 529,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 538,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 535,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 611,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 581,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 873,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 602,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 591,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 577,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1160,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1191,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 588,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 579,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 575,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1033,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1027,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1194,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 576,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1022,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 571,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 578,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1207,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 599,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 897,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 608,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 609,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 2632,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 881,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1032,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1212,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1167,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1192,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 2626,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 615,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1179,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 606,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.METAL,
    textureId: 2302,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.TILE,
    textureId: 2202,
    hasThumbnail: true,
    name: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.TILE,
    textureId: 104,
    hasThumbnail: true,
    name: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.TILE,
    textureId: 490,
    hasThumbnail: true,
    name: ColorGroup.BEIGE,
  },
];

const JamesHardieMenuItems = [
  // @@@@ original menu items without various siding types for James Hardie @@@@

  // Brick
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 47,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 194,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 433,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 143,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 449,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 163,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 448,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 307,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 190,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 131,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 207,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 793,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 792,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 135,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 162,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 87,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 321,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 320,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 239,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 368,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 110,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 246,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 136,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 331,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 510,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 398,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 336,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 36,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },

  // Stone
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 184,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 185,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 181,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 90,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 188,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 195,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 756,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 726,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 727,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 91,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 749,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 177,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 316,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 180,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 754,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 753,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 747,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 198,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 724,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 179,
    hasThumbnail: true,
    colorGroup: ColorGroup.MIXED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 752,
    hasThumbnail: true,
    colorGroup: ColorGroup.MIXED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 757,
    hasThumbnail: true,
    colorGroup: ColorGroup.MIXED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 755,
    hasThumbnail: true,
    colorGroup: ColorGroup.MIXED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 253,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 751,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 280,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 390,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 183,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 196,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 748,
    hasThumbnail: true,
    colorGroup: ColorGroup.DARK,
  },

  // roof
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 563,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 557,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1558,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 554,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 560,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 568,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 565,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 851,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 859,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 2207,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 556,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 858,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1547,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 2213,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 564,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 555,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1545,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 562,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 2210,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 569,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 160,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 524,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 617,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 619,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 651,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 527,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 101,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 951,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 971,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 734,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 541,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 653,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 542,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 533,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 515,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 531,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 950,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 548,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 98,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 965,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 523,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 534,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 532,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 543,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 553,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 158,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 537,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 99,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 530,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 161,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 539,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 614,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 733,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 552,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 540,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 97,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 550,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 96,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1310,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 656,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 963,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 528,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 529,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 538,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 535,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 611,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 581,
    hasThumbnail: true,
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 873,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 602,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 591,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 577,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1160,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1191,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 588,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 579,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 575,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1033,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1027,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1194,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 576,
    hasThumbnail: true,
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1022,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 571,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 578,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1207,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 599,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 897,
    hasThumbnail: true,
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 608,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 609,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 2632,
    hasThumbnail: true,
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 881,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1032,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1212,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1167,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1192,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 2626,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 615,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1179,
    hasThumbnail: true,
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 606,
    hasThumbnail: true,
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.METAL,
    textureId: 2302,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.TILE,
    textureId: 2202,
    hasThumbnail: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.TILE,
    textureId: 104,
    hasThumbnail: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.TILE,
    textureId: 490,
    hasThumbnail: true,
  },
  // ===== end original menu items ====

  // Shingled Siding
  {
    category: DesignConfigCategories.WALL,
    shape: Shapes.STRAIGHT_SHAKE,
    type: Types.SHINGLED_SIDING,
    textureId: 23,
    textureType: TextureTypes.CEDARMILL,
  },
  {
    category: DesignConfigCategories.WALL,
    shape: Shapes.STAGGERED_SHAKE,
    type: Types.SHINGLED_SIDING,
    textureId: 24,
    textureType: TextureTypes.CEDARMILL,
  },
  // Horizontal Siding
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `5"`,
    textureId: 623,
    textureType: TextureTypes.CEDARMILL,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `5"`,
    textureType: TextureTypes.SMOOTH,
    textureId: 624,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `6"`,
    textureId: 625,
    textureType: TextureTypes.CEDARMILL,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `6"`,
    textureId: 2270,
    textureType: TextureTypes.SMOOTH,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `7"`,
    textureId: 626,
    textureType: TextureTypes.CEDARMILL,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `7"`,
    textureId: 1299,
    textureType: TextureTypes.SMOOTH,
  },
  // vertical siding
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `8"`,
    textureId: 1267,
    textureType: TextureTypes.CEDARMILL,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `8"`,
    textureId: 1819,
    textureType: TextureTypes.SMOOTH,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `12"`,
    textureId: 1641,
    textureType: TextureTypes.CEDARMILL,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `12"`,
    textureId: 1987,
    textureType: TextureTypes.SMOOTH,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `16"`,
    textureId: 1268,
    textureType: TextureTypes.CEDARMILL,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `16"`,
    textureId: 1280,
    textureType: TextureTypes.SMOOTH,
  },
];

export {
  ColorGroup,
  JamesHardieMenuItems,
  MenuItems,
  MenuItemType,
  TextureColorGroupLabelColors,
};
